// biome-ignore-all lint/performance/noBarrelFile: intentional public entry point for the Labs shared component kernel (screens compose these atoms)
// fs-* native shared atoms for the Labs engine screens.
// Built ONLY against the fs-* token layer + DM Serif Display (font-dm) / Inter. Compose these
// instead of re-deriving CSS per screen (that drift caused the 18-vs-16px card-title token bug).
// Every atom here is vertical-agnostic: it takes content as props and reads nothing from a pack
// except <SubjectLogo>, which takes a LabsSubject.
export { BrandButton } from './brand-button';
export { CompleteBeat } from './complete-beat';
export { Confetti, type ConfettiProps } from './confetti';
export { LabsTrialBar } from './labs-trial-bar';
export { MetaTag } from './meta-tag';
export { NumberedAvatar } from './numbered-avatar';
export { PillTag } from './pill-tag';
export { BackButton, StepNav } from './step-nav';
export { SubjectLogo } from './subject-logo';
